
import moment from "moment"
import { GetSharedConnection, GetUsageConnection } from "../database/Database"
import DataValue from "../DataValue"
import { ContractTariff } from "../entity/shared/ContractTariff"
import { ContractTariffLiveData } from "../entity/shared/ContractTariffLiveData"
import { Tele2Details } from "../entity/usage/Tele2Details"
import { WirelessLogicDetails } from "../entity/usage/WirelessLogicDetails"
import { ExtendedContractTariff } from "../ExtendedContractTariff"
import { SimEssentials, SimStatus } from "../SimEssentials"

export function updateLiveDataForClient(contractTariff:any) {
  return new Promise<ContractTariffLiveData>(async (resolve, reject) => {
    try {

      // Get Connections
      let usageConnection = await GetUsageConnection()

      // Get Repositories
      let tele2SimDetailsRepo      = usageConnection.getRepository(Tele2Details)
      let wirelessLogicDetailsRepo = usageConnection.getRepository(WirelessLogicDetails)

      // Get sims for client from all sources
      let tele2Sims = await tele2SimDetailsRepo.find({where: { accountCustom1: contractTariff.client_name }})
      let wlSims = await wirelessLogicDetailsRepo.find({ where: { custom_field1: contractTariff.client_name } })
      let allSims = [
        ...tele2Sims,
        ...wlSims
      ]

      let essentialSimData = allSims.map(sim => {
        return new SimEssentials(sim, contractTariff)
      })

      // Calculate live data vaules
      let simsInTariff = essentialSimData.filter(s => s.customerId == contractTariff.client_name && s.contractTariff?.tariff.name == contractTariff.tariff.name)
      let activeSims = simsInTariff.filter(s => s.status == SimStatus.Active)
      let allUsableSims = simsInTariff.filter(s => s.status == SimStatus.Active || s.status == SimStatus.Deactivated)
      let allowance = allUsableSims.length * contractTariff.tariff.data_value
      let proratedAllowance = activeSims.reduce((carry, value) => {
        return carry + getProratedTariffAllowance(value, new DataValue(contractTariff.tariff.data_value)).value
      }, 0)
      let totalTransfer = allUsableSims.reduce((carry, current) => carry += current.total.value, 0)   
      let advisedDailyUsage = proratedAllowance / moment().daysInMonth()
      let advisedUsageToDate = advisedDailyUsage * moment().date()
      let usageRatio = (totalTransfer>0 && proratedAllowance>0) ? totalTransfer / proratedAllowance : 0
      let advisedUsageRatio = advisedUsageToDate / proratedAllowance || 0

      let liveData:ContractTariffLiveData = {
        allowance: allowance,
        prorated_allowance: proratedAllowance,
        total_sims: simsInTariff.length,
        active_sims: allUsableSims.length,
        currently_active_sims: activeSims.length,
        advised_daily_usage: Math.floor(advisedDailyUsage),
        advised_usage_to_date: Math.floor(advisedUsageToDate),
        usage_ratio: usageRatio,
        advised_usage_ratio: advisedUsageRatio,
        total_usage: totalTransfer,
        total_voice_usage: 0,
        total__sms_usage: 0
        //contract_tariff: contractTariff as ContractTariff
      } as ContractTariffLiveData

      resolve(liveData)

    } catch(e) {
      reject(e)
    }
  })
}

function getProratedTariffAllowance(sim:SimEssentials, monthlyTariff:DataValue){ 

  if(!sim.dateActivated) return monthlyTariff;
  if(moment().month() != moment(sim.dateActivated).month()) return monthlyTariff;

  let activationDate = moment(sim.dateActivated);
  let daysInMonth = activationDate.daysInMonth();
  let dayInMonth = activationDate.date();

  let proratedAllowance = new DataValue( 
    monthlyTariff.value / daysInMonth * (daysInMonth - dayInMonth) 
  )
  return proratedAllowance;
}